export default __webpack_public_path__ + "static/media/KWL_Banking_Information.94054ecb.jpg";